module.exports = __webpack_public_path__ + "img/dashboard.90e2387c.svg";